export default "__VITE_ASSET__Bf$ksIjE__"